"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = void 0;
const axios_1 = __importDefault(require("axios"));
const debug_1 = __importDefault(require("debug"));
const index_js_1 = require("../tron-networks/index.js");
const debugApiResponse = debug_1.default("java-tron-provider:api");
// TODO: refactor to use cross-fetch?
// TODO: memoize to speed up?
function createClient(tronApiUrl = index_js_1.networkToTronApiUrl("mainnet")) {
    const client = axios_1.default.create({
        baseURL: tronApiUrl,
        headers: {
            "Content-Type": "application/json",
        },
    });
    // Add a response interceptor
    client.interceptors.response.use((response) => __awaiter(this, void 0, void 0, function* () {
        debugApiResponse(response.data);
        // TODO: put maybeThrowJavaTronError call here?
        return response;
    }));
    return client;
}
exports.createClient = createClient;
function createContext({ network = "mainnet", tronApiUrl: tronApiUrl_ = null, tronEventsApiUrl: tronEventsApiUrl_ = null, tronLogsApiUrl: tronLogsApiUrl_ = null, config = {}, privateKey = "", mapBytecode, signs, } = {}) {
    const tronApiUrl = tronApiUrl_ || index_js_1.networkToTronApiUrl(network);
    const tronClient = createClient(tronApiUrl);
    const tronEventsClient = (() => {
        // not supported by shasta, will fall back to slow method for fetching logs
        try {
            const tronEventsApiUrl = tronEventsApiUrl_ || index_js_1.networkToTronEventsApiUrl(network);
            return createClient(tronEventsApiUrl);
        }
        catch (err) {
            return null;
        }
    })();
    // @opentron/tron-logs-index server client (obsoletes tronEventsClient)
    const tronLogsClient = (() => {
        // only supported for mainnet...
        try {
            const tronLogsApiUrl = tronLogsApiUrl_ || index_js_1.networkToTronLogsApiUrl(network);
            return createClient(tronLogsApiUrl);
        }
        catch (err) {
            // console.log(err);
            return null;
        }
    })();
    return {
        tronClient,
        tronEventsClient,
        tronLogsClient,
        config,
        privateKey,
        mapBytecode,
        functionSignatures: signs,
    };
}
exports.default = createContext;
